import isNumber from "lodash/isNumber";

export const convertMinutesToNearestQuarterHour = (timeInMinutes: number) => {
  return isNumber(timeInMinutes)
    ? Math.round((timeInMinutes / 60) * 4) / 4
    : timeInMinutes;
};
